import React from "react";
import { Gauge } from "lucide-react";

export const SCORE_LABELS = {
  dust_load: "Dust load",
  residue_complexity: "Residue complexity",
  glass_complexity: "Glass complexity",
  detail_density: "Detail density",
  access_difficulty: "Access difficulty",
  property_readiness: "Property readiness",
};

const band = (t) => (t >= 75 ? "#f4a4a4" : t >= 50 ? "#E7CE93" : "#6ee7b7");

/**
 * Ascendia Property Score — an internal, admin-weighted service-planning indicator
 * (explicitly NOT scientific). Communicates complexity to justify the level of detailing.
 */
export const PropertyScoreCard = ({ score }) => {
  if (!score || typeof score.total !== "number") return null;
  const inputs = score.inputs || {};
  const color = band(score.total);
  const cats = Object.keys(SCORE_LABELS).filter((k) => inputs[k] != null);
  return (
    <div className="ascendia-card p-6" data-testid="property-score-card">
      <div className="flex flex-col sm:flex-row sm:items-center gap-6">
        {/* Dial */}
        <div className="flex items-center gap-4">
          <div className="relative h-20 w-20 shrink-0">
            <svg viewBox="0 0 36 36" className="h-20 w-20 -rotate-90">
              <circle cx="18" cy="18" r="15.5" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="3" />
              <circle cx="18" cy="18" r="15.5" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round"
                strokeDasharray={`${(score.total / 100) * 97.4} 97.4`} />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span className="font-display text-xl font-semibold text-white" data-testid="score-total">{score.total}</span>
              <span className="text-[9px] text-muted-c -mt-0.5">/ 100</span>
            </div>
          </div>
          <div className="sm:hidden">
            <p className="kicker flex items-center gap-1.5"><Gauge className="h-3.5 w-3.5 text-gold-soft" /> Property Score</p>
          </div>
        </div>
        <div className="flex-1">
          <p className="kicker hidden sm:flex items-center gap-1.5 mb-1"><Gauge className="h-3.5 w-3.5 text-gold-soft" /> Ascendia Property Score</p>
          <p className="text-sm text-secondary">{score.rationale}</p>
          {cats.length > 0 && (
            <div className="mt-4 grid sm:grid-cols-2 gap-x-6 gap-y-2">
              {cats.map((k) => (
                <div key={k} className="flex items-center gap-2">
                  <span className="w-28 shrink-0 text-[11px] text-muted-c">{SCORE_LABELS[k]}</span>
                  <span className="flex-1 h-1.5 rounded-full bg-white/8 overflow-hidden">
                    <span className="block h-full rounded-full" style={{ width: `${(inputs[k] / 10) * 100}%`, backgroundColor: color }} />
                  </span>
                  <span className="w-6 text-right text-[11px] text-secondary">{inputs[k]}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyScoreCard;
